import { render } from "./EditorMain.vue?vue&type=template&id=cec2defc"
import script from "./EditorMain.vue?vue&type=script&lang=js"
export * from "./EditorMain.vue?vue&type=script&lang=js"

import "./EditorMain.vue?vue&type=style&index=0&id=cec2defc&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__